










import Vue from 'vue';


export default Vue.extend({
  name: 'icon-settings',
  props: {
    color: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
  },
});
